import {ReducerState} from 'rootReducer';

export default (state: ReducerState) => state.schedules;
